"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8996],{

/***/ 8996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ addBVCollectionPageCallback; },
/* harmony export */   "BF": function() { return /* binding */ substractDays; },
/* harmony export */   "CB": function() { return /* binding */ handleColorNameFormat; },
/* harmony export */   "CP": function() { return /* binding */ handleMouseEvent; },
/* harmony export */   "Cp": function() { return /* binding */ customSuperJsonParse; },
/* harmony export */   "DG": function() { return /* binding */ getRGBFromHexColor; },
/* harmony export */   "DN": function() { return /* binding */ getCanonicalURL; },
/* harmony export */   "DY": function() { return /* binding */ isIEorEdge; },
/* harmony export */   "Do": function() { return /* binding */ getCookieValue; },
/* harmony export */   "FP": function() { return /* binding */ documentGetElementByClassName; },
/* harmony export */   "FS": function() { return /* binding */ addBVProductPageCallback; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "HJ": function() { return /* binding */ documentGetElementById; },
/* harmony export */   "Jy": function() { return /* binding */ addBVScript; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "L3": function() { return /* binding */ smoothVerticalScroll; },
/* harmony export */   "ML": function() { return /* binding */ asyncForEach; },
/* harmony export */   "MX": function() { return /* binding */ enableDisableFocusOnElements; },
/* harmony export */   "Ms": function() { return /* binding */ setMonths; },
/* harmony export */   "Nt": function() { return /* binding */ getColorStyle; },
/* harmony export */   "R4": function() { return /* binding */ addRemainder; },
/* harmony export */   "Sm": function() { return /* binding */ stringToCapitalize; },
/* harmony export */   "Tq": function() { return /* binding */ getFileExtensions; },
/* harmony export */   "VP": function() { return /* binding */ getReviewAndRatingId; },
/* harmony export */   "Vt": function() { return /* binding */ stripHtml; },
/* harmony export */   "WI": function() { return /* binding */ splitIntoTwoArrays; },
/* harmony export */   "XP": function() { return /* binding */ removeHtmlTag; },
/* harmony export */   "Zl": function() { return /* binding */ customJsonstringify; },
/* harmony export */   "a9": function() { return /* binding */ toggleScroll; },
/* harmony export */   "dj": function() { return /* binding */ focusOnElement; },
/* harmony export */   "ep": function() { return /* binding */ getDateInNinetyDays; },
/* harmony export */   "er": function() { return /* binding */ handleClickToScrollToRnRInPDP; },
/* harmony export */   "gB": function() { return /* binding */ redirectTo; },
/* harmony export */   "hD": function() { return /* binding */ customSuperJsonStringify; },
/* harmony export */   "l$": function() { return /* binding */ formatDateToStringValue; },
/* harmony export */   "l4": function() { return /* binding */ bestCleanAnnouncementBarAlignment; },
/* harmony export */   "lU": function() { return /* binding */ handleClickToScrollToRnR; },
/* harmony export */   "ll": function() { return /* binding */ calculateHeaderHeight; },
/* harmony export */   "mN": function() { return /* binding */ uniqBy; },
/* harmony export */   "nD": function() { return /* binding */ objectWithLabel; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "s9": function() { return /* binding */ checkPattern; },
/* harmony export */   "sz": function() { return /* binding */ handleGAEvents; },
/* harmony export */   "vG": function() { return /* binding */ createHtmlFriendlyId; },
/* harmony export */   "ve": function() { return /* binding */ loadScript; },
/* harmony export */   "vk": function() { return /* binding */ setYears; },
/* harmony export */   "w1": function() { return /* binding */ isIE; },
/* harmony export */   "zb": function() { return /* binding */ onClickBuyNow; }
/* harmony export */ });
/* unused harmony exports handleFindElement, addAttributes, stringToCamelCase, stripSpecialChars, addDays, addProductListforSearchContent */
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49376);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85827);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(65069);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64765);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(38862);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(73210);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(70189);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(27207);
/* harmony import */ var core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_string_replace_all_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_es_date_to_iso_string_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(35268);
/* harmony import */ var core_js_modules_es_date_to_iso_string_js__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_iso_string_js__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var superjson__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(84419);
/* harmony import */ var _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(24036);








function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


































 // Returns if a value is a string

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}
function isObject(value) {
  return typeof value === 'object' || value instanceof Object;
}
function handleFindElement() {
  setTimeout(function () {
    var buttonElement = document.getElementById('ratings-summary');

    if (buttonElement) {
      buttonElement.setAttribute('role', 'button');
    }

    var activeListItems = document.getElementById('bv-dropdown-select-reviews-sortby');
    Array.isArray(activeListItems) && activeListItems.length > 0 && activeListItems.setAttribute('role', 'listbox');
    var reviewInput = document.getElementById('bv-text-field-search-contentSearch1');
    Array.isArray(reviewInput) && reviewInput.length > 0 && reviewInput.setAttribute('aria-label', labelConstant.reviewLabel);

    if (true) {
      var optionElement = window.document.getElementById('bv-dropdown-select-reviews');

      if (optionElement) {
        optionElement.setAttribute('role', 'option');
      }
    }
  }, 5000);
}
var handleColorNameFormat = function handleColorNameFormat(colorName) {
  var splitName = colorName.toLowerCase().split('-');
  var joinName = '';

  if (Array.isArray(splitName)) {
    var reduceName = '';
    reduceName = splitName.reduce(function (a, e) {
      a.push(e.charAt(0).toUpperCase() + e.substr(1));
      return a;
    }, []);
    joinName = reduceName.join(' ').toString();
  }

  return joinName;
};
function addAttributes() {
  var listItems = document.getElementsByClassName('bv-dropdown-target');
  listItems.length > 0 && listItems.forEach(function (listItem) {
    if (listItem.attributes.role) {
      listItem.setAttribute('role', 'listbox');
      listItem.setAttribute('aria-label', 'Sort By');
      listItem.forEach(function (listchild) {
        if (listItem.children.className.indexOf('bv-focusable') > -1) {
          listchild.children.setAttribute('role', 'button');
        }
      });
    }
  });
  var reviewListItems = document.getElementsByClassName('bv-dropdown-active');
  reviewListItems.length > 0 && reviewListItems.forEach(function (reviewListItem) {
    if (reviewListItem.attributes.role) {
      reviewListItem.setAttribute('role', 'listbox');
    }

    reviewListItem.setAttribute('aria-expanded', false);
    reviewListItem.addEventListener('keyup', function () {
      reviewListItem.setAttribute('aria-expanded', !reviewListItem.getAttribute('onKeyUp'));
    });
    reviewListItem.addEventListener('keypress', function () {
      reviewListItem.setAttribute('aria-expanded', !reviewListItem.getAttribute('onKeyPress'));
    });
    reviewListItem.addEventListener('click', function () {
      reviewListItem.setAttribute('aria-expanded', !reviewListItem.getAttribute('onClick'));
    });
    reviewListItem.forEach(function (childElement) {
      if (childElement.className.indexOf('bv-focusable') > -1) {
        childElement.setAttribute('role', 'option');
        childElement.setAttribute('aria-labelledby', labelConstant.reviewLabel);
        childElement.setAttribute('aria-selected', false);
        childElement.addEventListener('focus', function () {
          childElement.setAttribute('aria-selected', true);
        });
        childElement.addEventListener('blur', function () {
          childElement.setAttribute('aria-selected', false);
        });
      }
    });
  });
  var selectItem = document.getElementsByClassName('bv-dropdown-select');
  selectItem.length > 0 && selectItem.forEach(function (selectItem) {
    if (selectItem.className == 'bv-select-cleanslate bv-dropdown-select') {
      selectItem.addEventListener('change', function (value) {
        value.forEach(function (value) {
          if (value.target.children.attributes.selected) {
            value.target.children.setAttribute('aria-selected', true);
          }
        });
      });
    }
  });
  var dropDownControls = document.getElementsByClassName('bv-filter-controls');
  dropDownControls.length > 0 && dropDownControls.forEach(function (dropDownControls) {
    if (dropDownControls.className.indexOf('bv-focusable') > -1 && dropDownControls.attributes.tabindex) {
      dropDownControls.setAttribute('tabindex', 0);
    }
  });
  Array.isArray(document.getElementsByClassName('zone-header')) && document.getElementsByClassName('zone-header')[0].length > 0 && document.getElementsByClassName('zone-header')[0].removeAttribute('aria-hidden');
  Array.isArray(document.getElementsByClassName('host-box')) && document.getElementsByClassName('host-box')[0].length > 0 && document.getElementsByClassName('host-box')[0].removeAttribute('role');
  var html = document.getElementsByTagName('html'),
      lang;

  if (html.length > 0) {
    lang = html.lang.value;
    html.setAttribute('lang', lang);
  }

  var scaling = document.getElementsByTagName('meta');
  scaling.length > 0 && scaling.removeAttribute('user-scalable');
  var activeListItems = document.getElementById('bv-dropdown-select-reviews-sortby');

  if (activeListItems) {
    activeListItems.setAttribute('role', 'listbox');
  }

  var dropdownfield = document.getElementsByClassName('bv-dropdown-target');
  dropdownfield.length > 0 && dropdownfield.setAttribute('role', 'listbox');
  var reviewInput = document.getElementById('bv-text-field-search-contentSearch1');
  Array.isArray(reviewInput) && reviewInput.length > 0 && reviewInput.setAttribute('aria-label', reviewInput.placeholder);
}
function calculateHeaderHeight() {
  // Not really clean, but we have to do this this way to change
  // the layout's padding due to the sticky navigation
  var header = document.querySelector('.zone-header');
  var height = header ? header.clientHeight : 0;
  var layout = document.querySelector('.layout:not(.ob-spotlight-layout):not(.scrolling-header)');

  if (!layout) {
    return;
  }

  layout.style.paddingTop = "".concat(height, "px");
}
function getColorStyle(color) {
  if (color) {
    var _color$fields, _color$fields2, _color$fields3, _color$fields4;

    var colorCode = color == null ? void 0 : (_color$fields = color.fields) == null ? void 0 : _color$fields.colorCode;
    var colorCodeTop = (color == null ? void 0 : (_color$fields2 = color.fields) == null ? void 0 : _color$fields2.colorCodeTop) || colorCode;
    var colorCodeBottom = (color == null ? void 0 : (_color$fields3 = color.fields) == null ? void 0 : _color$fields3.colorCodeBottom) || colorCode;
    var gradientStyle = color == null ? void 0 : (_color$fields4 = color.fields) == null ? void 0 : _color$fields4.gradientStyle;

    switch (gradientStyle) {
      case 'linear':
        return {
          backgroundColor: colorCode,
          backgroundImage: "linear-gradient(to bottom, ".concat(colorCodeTop, " 0%, ").concat(colorCodeBottom, " 100%)")
        };

      case 'highlightTop':
        return {
          backgroundColor: colorCode,
          backgroundImage: "radial-gradient(circle at center top, ".concat(colorCodeTop, " 0%, ").concat(colorCodeBottom, " 100%)")
        };

      case 'highlightBottom':
        return {
          backgroundColor: colorCode,
          backgroundImage: "radial-gradient(circle at center bottom, ".concat(colorCodeBottom, " 0%, ").concat(colorCodeTop, " 100%)")
        };

      default:
        if (colorCode) {
          return {
            backgroundColor: colorCode
          };
        } else {
          return {};
        }

    }
  } else {
    return {};
  }
}
function getRGBFromHexColor(color) {
  var red = 0;
  var green = 0;
  var blue = 0;
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);

  if (result) {
    red = parseInt(result[1], 16);
    green = parseInt(result[2], 16);
    blue = parseInt(result[3], 16);
  }

  return {
    red: red,
    green: green,
    blue: blue
  };
} // Cross browser compatible version of window.scrollTo(options)

function smoothVerticalScroll(element, where) {
  var extraElemHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
  // The extraElementHeight is the height of any element that isn't accounted by element.getBoundingClientRect().top
  var header = document.querySelector('.zone-header:not(.visible-false)');
  var headerHeight = (header == null ? void 0 : header.offsetHeight) ? header.offsetHeight : 0;
  var elementTop = element.getBoundingClientRect().top;
  var elementAmount = (elementTop - headerHeight - extraElemHeight) / 100;
  var currentTime = 0;

  while (currentTime <= time) {
    window.setTimeout(smoothVerticalScrollBehaviour, currentTime, elementAmount, where);
    currentTime += time / 100;
  }
}

function smoothVerticalScrollBehaviour(elementAmount, where) {
  if (where === 'center' || where === '') {
    window.scrollBy(0, elementAmount / 2);
  }

  if (where === 'top') {
    window.scrollBy(0, elementAmount);
  }
}

function focusOnElement(element) {
  if (!element) {
    return;
  }

  element.setAttribute('tabindex', -1);
  setTimeout(function () {
    element.focus();
    element.addEventListener('blur', function (event) {
      event.currentTarget.removeAttribute('tabindex');
    });
  }, 500);
}
function toggleScroll(condition, lastScroll) {
  if (condition) {
    document.body.classList.add('noScroll');
    document.body.style.top = "-".concat(lastScroll, "px");
    document.body.style.height = "-".concat(lastScroll, "px");
  } else {
    document.body.classList.remove('noScroll');
    document.body.style.top = null;
    document.body.style.height = null;
    window.scrollTo(0, lastScroll);
  }
}
function stripHtml(html) {
  var stripHtmlResult;

  if (html) {
    stripHtmlResult = html.replace(/<[^>]+>/g, '');
    stripHtmlResult = stripHtmlResult.replace(/&nbsp;/g, ' ');
  } else {
    stripHtmlResult = '';
  }

  return stripHtmlResult;
}
function isIE() {
  if (true) {
    var ua = window.navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/

    var is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    return is_ie;
  }

  return false;
}
function isIEorEdge() {
  // Created a separate function in case we want to target Edge as well as old IE
  // isIE function will be used to target non-edge IE
  if (true) {
    var ua = window.navigator.userAgent;
    var is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Edge/') > -1;
    return is_ie;
  }

  return false;
}
function stringToCamelCase() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var splitStr = string.toLowerCase().split(' ');

  for (var i = 0; i < splitStr.length; i++) {
    if (splitStr.indexOf(splitStr[i]) !== 0) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
  }

  return splitStr.join('').replace(/[^a-zA-Z]+/g, '');
}
function stringToCapitalize() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var splitStr = string.toLowerCase().split(' ');

  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(' ');
}
function stripSpecialChars() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/[^a-zA-Z ]+/g, '');
}
function isObjectEmpty(object) {
  for (var key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      return false;
    }
  }

  return true;
}
var setMonths = function setMonths() {
  var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var months = [];

  for (var i = 0; i <= 12; i++) {
    if (i === 0) {
      months.push({
        id: label,
        value: label
      });
    } else if (i < 10 && i > 0) {
      months.push({
        id: i,
        value: '0' + i.toString()
      });
    } else {
      months.push({
        id: i,
        value: i.toString()
      });
    }
  }

  return months;
};
var setYears = function setYears() {
  var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var startYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1900;
  var years = [{
    id: label,
    value: label
  }];
  var currentYear = new Date().getFullYear();

  for (var i = currentYear; i >= startYear; i--) {
    years.push({
      id: i.toString(),
      value: i.toString()
    });
  }

  return years;
};
function objectWithLabel(object) {
  // return new object with value fields.text
  // that usually come from Label contentful component
  // Also remove the object from the list if .fields.text is undefined/null
  // return {key : fields.text}
  var newObject = {};

  for (var property in object) {
    var _object$property, _object$property$fiel;

    if ((_object$property = object[property]) == null ? void 0 : (_object$property$fiel = _object$property.fields) == null ? void 0 : _object$property$fiel.text) {
      var _object$property2, _object$property2$fie;

      newObject[property] = (_object$property2 = object[property]) == null ? void 0 : (_object$property2$fie = _object$property2.fields) == null ? void 0 : _object$property2$fie.text;
    }
  }

  return newObject;
}
function addDays(date, days) {
  var copy = new Date(Number(date));
  copy.setDate(date.getDate() + days);
  return copy;
}
function substractDays(date, days) {
  var copy = new Date(Number(date));
  copy.setDate(date.getDate() - days);
  return copy;
}
function formatDateToStringValue(strDate, srcFormat, dstFormat) {
  var dateMomentObject = moment__WEBPACK_IMPORTED_MODULE_38___default()(strDate, srcFormat);
  return dateMomentObject.format(dstFormat);
}
function formatDate(date) {
  var joinChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'yyyy-mm-dd';
  var dateFormat = date;
  var strDate = date.toString();
  var splitDate = strDate && strDate.split("/");

  if (isIE() || splitDate.shift().length === 2) {
    dateFormat = strDate.split('/').reverse().join('/');
  }

  var d = new Date(dateFormat),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }

  if (day.length < 2) {
    day = '0' + day;
  }

  if (format === 'yyyy-mm-dd') {
    return [year, month, day].join(joinChar);
  } else if (format === 'dd-mm-yyyy') {
    return [day, month, year].join(joinChar);
  }
}
function getDateInNinetyDays() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return addDays(date, 90);
}
function splitIntoTwoArrays() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (array.length < 2) {
    console.error('Please provide an array with at least 2 elements');
    return;
  }

  var halfOfArray = Math.floor(array.length / 2);
  var firstHalf = array.slice(0, halfOfArray);
  var secondHalf = array.slice(halfOfArray);
  return [firstHalf, secondHalf];
}
function getReviewAndRatingId(productOverview) {
  var reviewAndRatingId;

  if (productOverview) {
    var _productOverview$fiel;

    var productVariants = productOverview == null ? void 0 : (_productOverview$fiel = productOverview.fields) == null ? void 0 : _productOverview$fiel.productVariants;

    if (productVariants) {
      for (var i = 0; i < productVariants.length; i++) {
        var productVariant = productVariants[i];

        if (productVariant.fields.isBazaarVoiceIdentifier) {
          var _productVariant$field;

          reviewAndRatingId = productVariant == null ? void 0 : (_productVariant$field = productVariant.fields) == null ? void 0 : _productVariant$field.bazaarVoiceId; // if reviewAndRatingId is null use sku/ean

          if (reviewAndRatingId === undefined) {
            var sku = productVariant.fields.sku;

            if (sku) {
              reviewAndRatingId = sku;
            } else if (sku === undefined) {
              var ean = productVariant.fields.ean;
              reviewAndRatingId = ean;
            }

            if (reviewAndRatingId === undefined) {
              var _productVariant$field2;

              console.error('No reviewAndRatingId specified for product variant Bazaar Voice identifier:', productVariant == null ? void 0 : (_productVariant$field2 = productVariant.fields) == null ? void 0 : _productVariant$field2.name);
            }
          }
        }
      }
    }
  }

  return reviewAndRatingId;
}
function loadScript(source, callback) {
  var script = document.createElement('script');
  script.src = source;

  script.onload = function () {
    return callback(null, script);
  };

  script.onerror = function () {
    return callback(new Error("Script load error for ".concat(source)));
  };

  var head = document.getElementsByTagName('head');

  if (head) {
    head[0].appendChild(script);
  }
}
function asyncForEach(_x, _x2, _x3) {
  return _asyncForEach.apply(this, arguments);
}

function _asyncForEach() {
  _asyncForEach = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_6___default().mark(function _callee(array, container, callback) {
    var index;
    return _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_6___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return callback(array[index], container);

          case 4:
            index++;
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncForEach.apply(this, arguments);
}

function createHtmlFriendlyId(text) {
  // This strips all the dashes and replaces spaces to dashes.
  // This makes it easier to read and provides nice and clean ids
  return text.toLowerCase().replace(/ - /g, '-').replace(/ /g, '-');
}
function checkPattern(input) {
  return input.value.search(new RegExp(input.getAttribute('pattern'))) < 0;
}
function enableDisableFocusOnElements(container, enable) {
  if (container) {
    var allLinks = container.querySelectorAll('* > a');

    if (allLinks && allLinks.length > 0) {
      var _iterator = _createForOfIteratorHelper(allLinks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          enableTabIndex(item, enable);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var allButtons = container.querySelectorAll('* > button');

    if (allButtons && allButtons.length > 0) {
      var _iterator2 = _createForOfIteratorHelper(allButtons),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          enableTabIndex(_item, enable);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    var allInputs = container.querySelectorAll('* > input');

    if (allInputs && allInputs.length > 0) {
      var _iterator3 = _createForOfIteratorHelper(allInputs),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item2 = _step3.value;
          enableTabIndex(_item2, enable);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }
}
function handleClickToScrollToRnR() {
  var data = customSuperJsonParse(sessionStorage.getItem('PDP-Data'));
  setTimeout(function () {
    if (data && window.location.pathname == data.pdpURL && data.scrollRnR == "yes") {
      var rnrCta = document.getElementById('rnrButton');
      var rnrElement = document.getElementById('BVCustomerReviewContiner');

      if (rnrCta && rnrElement) {
        rnrCta.click();
      }

      sessionStorage.clear();
    }
  }, 2000);
}
function handleClickToScrollToRnRInPDP(url) {
  window.open(url, "_self");
  var pdpDetails = {
    pdpURL: url,
    scrollRnR: 'yes'
  };
  sessionStorage.setItem('PDP-Data', customSuperJsonStringify(pdpDetails));
}
function getCanonicalURL(path) {
  var scheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__/* .MetaConstants.https */ .FU.https;
  var url = "https://www.oralb.cz" + path;
  return url.includes(scheme) ? url : scheme + url;
}
function addBVScript() {
  // Render bazaarVoice script after the last render of the layout in the dom
  var bazaarVoiceURL = "https://apps.bazaarvoice.com/deployments/oralb-cs_cz/main_site/production/cs_CZ/bv.js";

  if (bazaarVoiceURL) {
    var s = document.createElement('script');
    s.async = true;
    s.type = 'text/javascript';
    s.src = "https://apps.bazaarvoice.com/deployments/oralb-cs_cz/main_site/production/cs_CZ/bv.js".replace(new RegExp('"', 'g'), '');
    var firstScript = document.getElementsByTagName('script')[0];

    if (firstScript) {
      firstScript.parentNode.insertBefore(s, firstScript);
    }
  } else {
    return console.log('Please set a bazaarVoiceURL');
  }
}
function addBVCollectionPageCallback() {
  window.setTimeout(function () {
    var inlineRating = document.querySelectorAll("[data-bv-show='inline_rating']");

    if (inlineRating) {
      for (var i = 0; i < inlineRating.length; i++) {
        var inlineRatingElement = inlineRating[i];
        inlineRatingElement.classList.remove('no-reviews');

        if (inlineRatingElement.innerText.includes('(0)')) {
          inlineRatingElement.classList.add('no-reviews');
        }
      }
    }
  }, 2000);
}
function addBVProductPageCallback(productName) {
  window.bvCallback = function (BV) {
    var _window, _BV$reviews;

    function addAnalyticClassToBazaarVoiceElement(elementClass, analyticHookClass, dataActionDetail, parentElementClass, attributeToReadForValue, removeFromValue) {
      if (typeof document != 'undefined') {
        var rootElement = document;

        if (parentElementClass) {
          var parent = document.getElementsByClassName(parentElementClass);

          if (parent && parent.length > 0 && typeof parent[0] != 'undefined') {
            rootElement = parent[0];
          }
        }

        var elements = rootElement.getElementsByClassName(elementClass);

        if (elements && elements.length > 0) {
          //Add some GA class to track bv event
          for (var _i = 0; _i < elements.length; _i++) {
            var valueActionDetail = dataActionDetail;

            if (typeof elements[_i] != 'undefined' && elements[_i] != null) {
              elements[_i].classList.add(analyticHookClass);

              if (attributeToReadForValue) {
                var value = '';

                if (elements[_i].getAttribute(attributeToReadForValue)) {
                  value = elements[_i].getAttribute(attributeToReadForValue);

                  if (removeFromValue) {
                    value = value.replace(removeFromValue, '');
                  }
                }

                valueActionDetail = valueActionDetail.replace('%value%', value);
              }

              elements[_i].setAttribute('data-action-detail', valueActionDetail);
            }
          }
        }
      }
    }

    if ((_window = window) == null ? void 0 : _window.bvDCC) {
      for (var i = 0, len = window.bvDCC.catalogData.catalogProducts.length; i < len; ++i) {
        BV.pixel.trackEvent('CatalogUpdate', {
          type: 'Product',
          locale: window.bvDCC.catalogData.locale,
          catalogProducts: [window.bvDCC.catalogData.catalogProducts[i]]
        });
      }
    }

    (_BV$reviews = BV.reviews) == null ? void 0 : _BV$reviews.ready().then(function () {
      window.setTimeout(function () {
        addAnalyticClassToBazaarVoiceElement('bv_button_buttonFull', 'event_product_review', productName, 'bv_main_container_CTA_row');
        addAnalyticClassToBazaarVoiceElement('bv-focusable', 'event_button_click', 'Open Dropdown Menu', 'bv-control-bar-sort');
        addAnalyticClassToBazaarVoiceElement('bv-dropdown-target', 'event_button_click', 'Open Dropdown Menu', 'bv-control-bar-sort');
        addAnalyticClassToBazaarVoiceElement('bv-expand-filter-button', 'event_button_click', 'Open Dropdown Menu');
        addAnalyticClassToBazaarVoiceElement('bv-content-btn-feedback-yes', 'event_button_click', 'Helpful Yes');
        addAnalyticClassToBazaarVoiceElement('bv-content-btn-feedback-no', 'event_button_click', 'Helpful No');
        addAnalyticClassToBazaarVoiceElement('bv_avgRating', 'event_internal_link', 'See All Reviews Panel');
        addAnalyticClassToBazaarVoiceElement('bv_numReviews_text', 'event_internal_link', 'See All Reviews Panel');
        addAnalyticClassToBazaarVoiceElement('bv-content-btn-pages-load-more', 'event_button_click', 'See More Reviews');
        addAnalyticClassToBazaarVoiceElement('bv-dropdown-item', 'event_button_click', 'Filter %value%', 'bv-dropdown-active', 'data-bv-dropdown-value');
        addAnalyticClassToBazaarVoiceElement('bv-rating-link', 'event_button_click', 'Star Rating %value%', 'bv-submission-star-rating-control', 'id', 'bv-radio-rating-');
        addAnalyticClassToBazaarVoiceElement('bv-text', 'event_button_click', 'Form Field %value%', 'bv-fieldset-usernickname', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-select', 'event_button_click', 'Form Field %value%', 'bv-fieldset-contextdatavalue_AgeMonth', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-select', 'event_button_click', 'Form Field %value%', 'bv-fieldset-contextdatavalue_AgeYear', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-text', 'event_button_click', 'Form Field %value%', 'bv-email-field', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-text', 'event_button_click', 'Form Field %value%', 'bv-fieldset-userlocation', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-text', 'event_button_click', 'Form Field %value%', 'bv-fieldset-title', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-text', 'event_button_click', 'Form Field %value%', 'bv-fieldset-reviewtext', 'name');
        addAnalyticClassToBazaarVoiceElement('bv-form-actions-submit', 'event_button_click', 'Submit');
        addAnalyticClassToBazaarVoiceElement('bv-content-btn-pages-last', 'event_view_more_review', productName);
        addAnalyticClassToBazaarVoiceElement('bv_button_buttonMinimalist', 'event_product_review', productName);
        var Reviewsummary = document.getElementById('ratings-summary');

        if (Reviewsummary) {
          Reviewsummary.classList.add('event_product_review_view');
          Reviewsummary.setAttribute('data-action-detail', productName);
        } // Add a class on user block if 0 Reviews from BV.


        var reviewText = document.getElementsByClassName('bv_numReviews_component_container');

        if (reviewText.length > 0 && reviewText[0] !== null) {
          if (reviewText[0].innerText.includes('(0)')) {
            var userBlock = document.getElementsByClassName('ob-customer-review');

            if (userBlock[0] !== null && typeof userBlock[0] != 'undefined') {
              userBlock[0].classList.add('no-reviews');
            }
          }
        }

        var inlineRating = document.querySelector("[data-bv-show='inline_rating']");

        if (inlineRating !== null && inlineRating.innerText.includes('(0)')) {
          // Find inline-rating (0)
          inlineRating.classList.add('no-reviews');
        }
      }, 2000);
    });
  };
}

function enableTabIndex(item, enable) {
  if (!enable) {
    if (item.getAttribute('tabindex') && item.getAttribute('tabindex') >= 0) {
      item.setAttribute('data-previous-tabIndex', item.getAttribute('tabindex'));
    }

    item.setAttribute('tabindex', -1);
  } else {
    var newTabIndex = null;

    if (item.getAttribute('data-previous-tabIndex')) {
      newTabIndex = item.getAttribute('data-previous-tabIndex');
      item.setAttribute('tabindex', newTabIndex);
    } else {
      item.removeAttribute('tabindex');
    }
  }
}

function addProductListforSearchContent(productList) {
  var stringProductList = '';

  if (Array.isArray(productList) && productList.length > 0) {
    stringProductList = customSuperJsonStringify(productList);
  }

  return stringProductList;
}
function removeHtmlTag(query) {
  console.log('inside removeHTMLTag log: ', query);
  query = query.replace(/[&\/\\#$~%.'":*<>[\]{}]/g, '');
  return query;
}
function getCookieValue(name) {
  var _document$cookie$matc;

  return document && document.cookie && ((_document$cookie$matc = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')) == null ? void 0 : _document$cookie$matc.pop()) || '';
}
function handleGAEvents(gaEventCategory, gaEventAction, gaEventLabel) {
  window && window.dataLayer && window.dataLayer.push({
    event: 'customEvent',
    GAeventCategory: "".concat(gaEventCategory),
    GAeventAction: "".concat(gaEventAction),
    GAeventLabel: "".concat(gaEventLabel)
  });
}
;
var customJsonstringify = function customJsonstringify(str) {
  return JSON.stringify(str).replace(/([&"'<>])/g, function (char) {
    switch (char) {
      case '&':
        return "&";

      case '<':
        return "<";

      case '>':
        return ">";

      case '"':
        return "\"";

      case "'":
        return "'";

      default:
        return char;
    }
  });
};
var bestCleanAnnouncementBarAlignment = function bestCleanAnnouncementBarAlignment() {
  if (document.querySelector('.best-clean-layout') && document.getElementById('main')) {
    document.getElementById('main').style.marginTop = '121px';
  }
};
function getFileExtensions() {
  var _url$split$0$split$po;

  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!url) return false;
  return (_url$split$0$split$po = url.split(/[?]/)[0].split('.').pop().trim()) == null ? void 0 : _url$split$0$split$po.toLowerCase();
}
function documentGetElementById(id) {
  return document.getElementById(id);
}
function documentGetElementByClassName(className) {
  return document.getElementsByClassName(className);
}
var uniqBy = function uniqBy(arr, fn) {
  var set = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
  return arr == null ? void 0 : arr.filter(function (el) {
    return function (v) {
      return !set.has(v) && set.add(v);
    }(typeof fn === 'function' ? fn(el) : el[fn]);
  });
};
function onClickBuyNow(domainURL) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'customEvent',
      GAeventCategory: 'event_informational_action',
      GAeventAction: 'event_outbound_link',
      GAeventLabel: "".concat(domainURL)
    });
  }
}
;
var addRemainder = function addRemainder(calenderOption, selectedTypeOption) {
  var dt = new Date();
  var no_of_months = calenderOption == null ? void 0 : calenderOption.noOfMonths;
  var eventTitle = calenderOption == null ? void 0 : calenderOption.title;
  var eventNote = calenderOption == null ? void 0 : calenderOption.note;
  dt.setMonth(dt.getMonth() + no_of_months);
  var endDate = dt.toISOString().replaceAll(":", "").replaceAll("-", "").replaceAll(".", "");
  var date = dt.toISOString().replaceAll(":", "").replaceAll("-", "").split(".");
  var outlookDate = dt.toISOString().split(".");
  var url;
  var icsData;

  switch (selectedTypeOption.type) {
    case _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__/* .StartGuideBlockConstants.Google */ .T3.Google:
      url = (selectedTypeOption == null ? void 0 : selectedTypeOption.url) + eventTitle + "&dates=" + endDate + "/" + endDate + "&details=" + eventNote;
      window.open(url);

    case _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__/* .StartGuideBlockConstants.Yahoo */ .T3.Yahoo:
      url = (selectedTypeOption == null ? void 0 : selectedTypeOption.url) + eventTitle + "&st=" + endDate + "&et=" + endDate + "&desc=" + eventNote;
      window.open(url);

    case _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__/* .StartGuideBlockConstants.Outlook */ .T3.Outlook:
      url = (selectedTypeOption == null ? void 0 : selectedTypeOption.url) + "&startdt=" + outlookDate[0] + "Z" + "&enddt=" + outlookDate[0] + "Z" + "&subject=" + eventTitle + "&body=" + eventNote;
      window.open(url);

    case _helpers_Constants__WEBPACK_IMPORTED_MODULE_40__/* .StartGuideBlockConstants.Other */ .T3.Other:
      icsData = "BEGIN:VCALENDAR\nVERSION:2.0\r\n";
      icsData += "BEGIN:VEVENT\r\n";
      icsData += "DTSTART:" + date[0] + "Z" + "\r\n";
      icsData += "DTEND:" + date[0] + "Z" + "\r\n";
      icsData += "SUMMARY:".concat(eventTitle, "\r\n");
      icsData += "DESCRIPTION:".concat(eventNote, "\r\n");
      icsData += "LOCATION:\r\n";
      icsData += "BEGIN:VALARM\r\n";
      icsData += "TRIGGER:-PT15M\r\n";
      icsData += "ACTION:DISPLAY\r\n";
      icsData += "DESCRIPTION:REMINDER\r\n";
      icsData += "END:VALARM\r\nEND:VEVENT\r\nEND:VCALENDAR";
      window.open("data:text/calendar;charset=utf8," + encodeURIComponent(icsData));
  }
};
var customSuperJsonStringify = function customSuperJsonStringify(str) {
  try {
    return superjson__WEBPACK_IMPORTED_MODULE_39__/* ["default"].stringify */ .ZP.stringify(str).replace(/([&"'<>])/g, function (char) {
      switch (char) {
        case '&':
          return "&";

        case '<':
          return "<";

        case '>':
          return ">";

        case '"':
          return "\"";

        case "'":
          return "'";

        default:
          return char;
      }
    });
  } catch (error) {
    throw new Error("".concat(error.message));
  }
};
var customSuperJsonParse = function customSuperJsonParse(str) {
  try {
    return str && str.match('"json":') ? superjson__WEBPACK_IMPORTED_MODULE_39__/* ["default"].parse */ .ZP.parse(str) : JSON.parse(str);
  } catch (error) {
    throw new Error('Something went wrong!', error);
  }
};
function handleMouseEvent(eventType, event, image) {
  if (eventType === 'mouseover' || eventType === 'mouseout') {
    return event.currentTarget.src = image;
  }
}
function redirectTo(url) {
  window.location.href = url;
}

/***/ })

}]);